<template>
    <div class="modal-mask" role="dialog">
      <div class="overlay-mask">
        <div class="modal-dialog modal-md">
          <div class="modal-content modal-edit-bg">
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
                  <div class="close_btn" v-on:click="CloseModal()"></div><br>
                    <div class="row">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <swiper :options="swiperOptions" class="swiper-wrapper">
                            <swiper-slide v-for="(pic, index) in images" :key="index">
                              <img class="img-fluid" v-bind:src="pic" alt="Image Description">
                            </swiper-slide>
                            <div id="prev-image" class="level3-gallery-prev swiper-button-prev" slot="button-prev"></div>
                            <div id="next-image" class="level3-gallery-next swiper-button-next" slot="button-next"></div>
                          </swiper>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props: ['images', 'imageIndex'],
  components: {},
  data() {
    return {
      isModalShown: true,
      swiperOptions:{
          navigation: {
              prevEl: "#prev-image",
              nextEl: "#next-image"
          },
          initialSlide:0
      }
    }
  },
  methods: {
    CloseModal() {
      this.$emit('close');
    },
  },
  created() {
    this.swiperOptions.initialSlide = this.imageIndex;
  },
};
</script>


// WEBPACK FOOTER //
// FrameModal.vue?730dd435